// extracted by mini-css-extract-plugin
module.exports = {"backArrow":"BackArrowIcon__backArrow___1OJ3c"};